import { FetchHttpService } from "@soft-db/http/fetch";
import { createHttp } from "@soft-db/http/vue";

const url = import.meta.env.VITE_API_URL || "";

export const http = new FetchHttpService(url);

export const httpPlugin = createHttp(http);
